export enum AppErrorTypeEnum {

  AUTHENTICATION_ERROR,
  AUTHORIZATION_ERROR,
  SERVER_ERROR
}
